import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface ProductionDetailsProps {
  productionId: string; //e.g. "1312",
  productionName: string; //e.g. "test red",
  productionSetId: string; //e.g. "1",
  securityGroupId: string; //e.g. "1",
  isProduction: boolean;
  isProductionExternalSource: boolean;
}

interface CategorizationState {
  backSourceLabel?: string | null; //e.g. "Production",
  trainingSetName?: string | null; //e.g. "Production Guard Source",
  backSourcePath?: string | null;
  trainingSetType?: string | null; //e.g. "ExternalSource",
  proviewProductionDetails?: ProductionDetailsProps | null;
  corpusDetails?: {
    id: string; //e.g. ["1312"];
    type: string; //e.g. "production",
    text: string; //e.g.  "test red"
  } | null;
}

const initialState: CategorizationState = {
  backSourceLabel: null,
  trainingSetName: null,
  backSourcePath: null,
  trainingSetType: null,
  proviewProductionDetails: null,
  corpusDetails: null,
};

const categorizationSlice = createSlice({
  name: 'categorization',
  initialState,
  reducers: {
    setCategorizationState(state, action: PayloadAction<CategorizationState>) {
      const setKeys = Object.keys(initialState);
      setKeys.forEach((key) => {
        (state as any)[key] =
          action.payload[key as keyof CategorizationState] ?? null;
      });
    },
    clearCategorizationState(state) {
      const resetKeys = Object.keys(initialState);
      resetKeys.forEach((key) => {
        (state as any)[key] = initialState[key as keyof CategorizationState];
      });
    },
  },
});

export const {setCategorizationState, clearCategorizationState} =
  categorizationSlice.actions;
export default categorizationSlice.reducer;
